<div class="col-12 mainDiv">
	<div class="userDetailsContainer mb-3 mt-5">
		<div>
			<h3 class="styledUserDetails">
				Firstname Middlename Lastname
			</h3>
		</div>
		<div >
			<span class="styledDOB">DOB: </span>
			<span class="styledDOB-UserDetails">Jun 16, 2020</span>
		</div>
	</div>
	<div class="tableContainer">
		<div class="subHeading mb-3">
			<div>
				<h4 class="header-title">CANS</h4>
			</div>
			<div>
				<span class="bold-title">Version: </span>
				<span class="sub-title">CANS CA</span>
			</div>
		</div>
		<div>
			<table class="table">
				<thead>
					<tr class="removeHoverHeader">
						<th class="spaceCell">
							<div class="d-flex">
								<div class="titleHeader">
									Domain header1
								</div>
								<div class="titleIcon">
									<i title="Domain header1 title" class="fa fa-info-circle"></i>
								</div>
							</div>
						</th>
						<th class="value align-center">10</th>
						<th class="value align-center"></th>
						<th class="value align-center"></th>
						<th class="collapseBar">
							<span
							(click)="openTabs()">
								<i *ngIf="!showDetails" style="padding: 0" class="fa fa-caret-down removePad" aria-hidden="true"></i>
								<i *ngIf="showDetails" style="padding: 0" class="fa fa-caret-up removePad" aria-hidden="true"></i>
							</span>
						</th>
					</tr>
				</thead>
				<tbody class="TableBody" *ngIf="showDetails">
					<tr>
						<td class="spaceCell">
							<div class="title">
								<span class="d-flex">
									<a class="plusCircleIcon">
										<img *ngIf="!isShowCard" (click)= "showCard()" src="../../../assets/icons/Plus.png" alt="plusIcon">
										<img *ngIf="isShowCard" (click)= "hideCard()" src="../../../assets/icons/Minus_for_Popup.png" alt="plusIcon">
									</a>
								  <span class="labelTitle" title="Lorem Ipsum">Lorem Ipsum</span>
								</span>                                        
							</div>
						</td>
						<td class="value align-center">10</td>
					</tr>
					<tr class="removeHover" *ngIf="isShowCard">
						<td style="white-space: unset;" colspan="5">
							<div class="card toggleCard">
								<div class="card-body">
									<div class="details-row">
										<h2 class="subtitle">Item Description:</h2>
										<p class="versiontitle">Item descccccccc</p>
									</div>
									<div class="details-row mt-2">
										<h2 class="subtitle">Item Rating:</h2>
									</div>
									<div class="option radioStylesOverride">
										<div class="d-flex mb-2">
											<mat-radio-group  [disabled] = "true">
												<div class="d-flex">
													<mat-radio-button [checked]="true" [value]="true"></mat-radio-button>
													<div class="radioBtnDetails">
														<span><b>0</b> = </span>
														No current need; no need for action or intervention. No evidence of psychotic symptoms. Both thought processes and content are within normal range.
													</div>
												</div>
												<div class="d-flex">
													<mat-radio-button [checked]="false" [value]="false"></mat-radio-button>
													<div class="radioBtnDetails">
														<span><b>1</b> = </span>
														Identified need requires monitoring, watchful waiting, or preventive activities. Evidence of disruption in thought processes or content. Child/youth may be somewhat tangential in speech or evidence somewhat illogical thinking (age-inappropriate). This also includes child/youth with a history of hallucinations but none currently. Use this category for child/youth who are below the threshold for one of the DSM diagnoses listed above.
													</div>
												</div>
												<div class="d-flex">
													<mat-radio-button [checked]="false" [value]="false"></mat-radio-button>
													<div class="radioBtnDetails">
														<span><b>2</b> = </span>
                                                        Action or intervention is required to ensure that the identified need is addressed; need is interfering with functioning. Evidence of disturbance in thought process or content that may be impairing the child/youth's functioning in at least one life domain. Child/youth may be somewhat delusional or have brief intermittent hallucinations. Speech may be at times quite tangential or illogical.
													</div>
                                                </div>
                                                <div class="d-flex">
													<mat-radio-button [checked]="false" [value]="false"></mat-radio-button>
													<div class="radioBtnDetails">
                                                        <span><b>3</b> = </span>
                                                        Problems are dangerous or disabling; requires immediate and/or intensive action. Clear evidence of dangerous hallucinations, delusions, or bizarre behavior that might be associated with some form of psychotic disorder that places the child/youth or others at risk of physical harm.
													</div>
												</div>
											</mat-radio-group>
											<div>					
											</div>
										</div>
									</div>
									<div class="details-row mt-3 radioStylesOverride">
										<h2 class="subtitle ">Mark as Confidential:</h2>
										<mat-radio-group  [disabled] = "true">
											<mat-radio-button [checked]="true" [value]="true">Yes</mat-radio-button>
											<mat-radio-button [checked]="false" [value]="false" class="ml-3">No</mat-radio-button>
										</mat-radio-group>
									</div>
									<!-- Notes -->
									<div class="details-row mt-3">
										<h2 class="subtitle">Notes:</h2>
										<div>
											Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum
										</div>
									</div>
								</div>
							</div>
						</td>
					</tr>
	
					<tr>
						<td class="spaceCell">
							<div class="title">
								<span class="d-flex">
								  <a class="plusCircleIcon">
									<img src="../../../assets/icons/Plus.png" alt="plusIcon">
								  </a>
								  <span class="labelTitle" title="Lorem Ipsum">Lorem Ipsum</span>
								</span>                                        
							</div>
						</td>
						<td class="value align-center">10</td>
					</tr>
					<tr>
						<td class="spaceCell">
							<div class="title">
								<span class="d-flex">
								  <a class="plusCircleIcon">
									<img src="../../../assets/icons/Plus.png" alt="plusIcon">
								  </a>
								  <span class="labelTitle" title="Lorem Ipsum">Lorem Ipsum</span>
								</span>                                        
							</div>
						</td>
						<td class="value align-center">10</td>
					</tr>
					<tr>
						<td class="spaceCell">
							<div class="title">
								<span class="d-flex">
								  <a class="plusCircleIcon">
									<img src="../../../assets/icons/Plus.png" alt="plusIcon">
								  </a>
								  <span class="labelTitle" title="Lorem Ipsum">Lorem Ipsum</span>
								</span>                                        
							</div>
						</td>
						<td class="value align-center">10</td>
					</tr>
				</tbody>
			</table>
			<div class="reviewerItemsContainer">
				<div class="col-12 nopad d-flex">
					<div class="col-9 nopad">
						<h2 class="subtitle">Notes:</h2>
						<mat-form-field appearance="fill">
							<mat-label>Notes</mat-label>
							<textarea matInput></textarea>
						</mat-form-field>
					</div>
					<div class="col-3 nopad">
						<div class="approveRejectBtnContainer">
							<div>
								<button class="btn btnApprove">
									Approve 
								</button>
							</div>
							<div>
								<button class="btn btnReject">
									Return
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>